// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"134647b6","404":"9e00d86f","955":"e4e014df","982":"656f88bc"}[chunkId] + ".chunk.css";
};